import { Deserializable } from './deserializable';
import { BaseModel } from './baseModel';

export class AccessMethod extends BaseModel implements Deserializable {

  userUid: string;
  type: string;
  code: string;
  way : string;
  // prefix: string;
  // readerCount : number = -1;

  deserialize(input: any) {
    super.deserialize(input);
    Object.assign(this, input);

    // if(this.way.includes(AccessMethod.EVENT_TYPE_BADGE)){
    //   this.way = AccessMethod.EVENT_TYPE_BADGE;
    //   this.readerCount = Number(this.way.substr(this.way.length - 1));
    // }

    // if(this.way.includes(AccessMethod.EVENT_TYPE_PINCODE)){
    //   this.way = AccessMethod.EVENT_TYPE_PINCODE;
    //   this.readerCount = Number(this.way.substr(this.way.length - 1));
    // }

    return this;
  }

  static EVENT_TYPE_APP: string = "App";
  static EVENT_TYPE_CAR: string = "Car";
  static EVENT_TYPE_PHONE: string = "Phone";
  static EVENT_TYPE_REMOTE: string = "Remote";
  static EVENT_TYPE_REMOTE1CONTROL: string = "Remote1C";
  static EVENT_TYPE_WEB: string = "Web";
  static EVENT_TYPE_API: string = "Api";
  static EVENT_TYPE_BADGE: string = "Badge"
  static EVENT_TYPE_PINCODE: string = "PinCode";

  static TYPE: string[] = [
    AccessMethod.EVENT_TYPE_APP,
    AccessMethod.EVENT_TYPE_CAR,
    AccessMethod.EVENT_TYPE_PHONE,
    AccessMethod.EVENT_TYPE_REMOTE,
    AccessMethod.EVENT_TYPE_REMOTE1CONTROL,
    AccessMethod.EVENT_TYPE_BADGE,
    AccessMethod.EVENT_TYPE_PINCODE   
  ];
}
